// extracted by mini-css-extract-plugin
export default {"container":"MycawFollowUpTypeformList_container__2h7Dt"};